import BaseModel from '@/models/BaseModel'
import Customer from '@/models/Customer'

export default class CertificateRequest extends BaseModel {
    resourceName() {
        return 'certificate-request'
    }

    fields() {
        return [
            'type',
            'name',
            'document',
            'email',
            'phone',
            'payment_method',
            'installments',
            'price',
            'paid_at',
            'ticket_id',
            'reseller_id',
            'customer_id',
            'created_at',
        ]
    }

    relationships() {
        return {
            customer: new Customer(),
        }
    }

    computed() {
        return {
            paidAt(certificateRequest) {
                if (!certificateRequest.paid_at) {
                    return ''
                }

                const date = new Date(certificateRequest.paid_at)

                if (isNaN(date)) {
                    return ''
                }

                return `${date.getDate()}/${date.getMonth() +
                    1}/${date.getFullYear()}`
            },

            createdAt(certificateRequest) {
                const date = new Date(certificateRequest.created_at)

                if (isNaN(date)) {
                    return ''
                }

                return `${date.getDate()}/${date.getMonth() +
                    1}/${date.getFullYear()}`
            },

            customerName(certificateRequest) {
                return certificateRequest.customer.trade_name
            },
        }
    }

    get tableColumns() {
        return [
            {
                text: 'Cliente',
                value: 'customerName',
                sortable: false,
            },
            {
                text: 'Documento',
                value: 'document',
                sortable: false,
            },
            {
                text: 'Solicitado em',
                value: 'createdAt',
                sortable: false,
            },
            {
                text: 'Pago em',
                value: 'paidAt',
                sortable: false,
            },
        ]
    }
}
